export interface ResourceColor {
  block: string;
  dot: string;
}

// Full class names so Tailwind keeps them.
export const RESOURCE_COLORS: ResourceColor[] = [
  {
    block:
      'bg-blue-100 border-blue-500 text-blue-900 dark:bg-blue-900/60 dark:border-blue-400 dark:text-blue-100',
    dot: 'bg-blue-500',
  },
  {
    block:
      'bg-emerald-100 border-emerald-500 text-emerald-900 dark:bg-emerald-900/60 dark:border-emerald-400 dark:text-emerald-100',
    dot: 'bg-emerald-500',
  },
  {
    block:
      'bg-amber-100 border-amber-500 text-amber-900 dark:bg-amber-900/60 dark:border-amber-400 dark:text-amber-100',
    dot: 'bg-amber-500',
  },
  {
    block:
      'bg-rose-100 border-rose-500 text-rose-900 dark:bg-rose-900/60 dark:border-rose-400 dark:text-rose-100',
    dot: 'bg-rose-500',
  },
  {
    block:
      'bg-violet-100 border-violet-500 text-violet-900 dark:bg-violet-900/60 dark:border-violet-400 dark:text-violet-100',
    dot: 'bg-violet-500',
  },
  {
    block:
      'bg-cyan-100 border-cyan-500 text-cyan-900 dark:bg-cyan-900/60 dark:border-cyan-400 dark:text-cyan-100',
    dot: 'bg-cyan-500',
  },
  {
    block:
      'bg-orange-100 border-orange-500 text-orange-900 dark:bg-orange-900/60 dark:border-orange-400 dark:text-orange-100',
    dot: 'bg-orange-500',
  },
  {
    block:
      'bg-pink-100 border-pink-500 text-pink-900 dark:bg-pink-900/60 dark:border-pink-400 dark:text-pink-100',
    dot: 'bg-pink-500',
  },
  {
    block:
      'bg-teal-100 border-teal-500 text-teal-900 dark:bg-teal-900/60 dark:border-teal-400 dark:text-teal-100',
    dot: 'bg-teal-500',
  },
  {
    block:
      'bg-indigo-100 border-indigo-500 text-indigo-900 dark:bg-indigo-900/60 dark:border-indigo-400 dark:text-indigo-100',
    dot: 'bg-indigo-500',
  },
  {
    block:
      'bg-lime-100 border-lime-500 text-lime-900 dark:bg-lime-900/60 dark:border-lime-400 dark:text-lime-100',
    dot: 'bg-lime-500',
  },
  {
    block:
      'bg-fuchsia-100 border-fuchsia-500 text-fuchsia-900 dark:bg-fuchsia-900/60 dark:border-fuchsia-400 dark:text-fuchsia-100',
    dot: 'bg-fuchsia-500',
  },
];

export const resourceColor = (index: number): ResourceColor =>
  RESOURCE_COLORS[index % RESOURCE_COLORS.length];
